import React from 'react';
import { useTranslation } from 'react-i18next';
import { SvgIcon } from '@mui/material';
import { ReactComponent as cross } from '@/assets/icons/cross.svg';
import { ReactComponent as exclamatory } from '@/assets/icons/exclamatory.svg';
import styles from './SaveChangesModal.module.scss';

interface SaveChangesModalProps {
  onCancel: () => void;
  onClose: () => void;
  onDiscard?: () => void;
}

export const SaveChangesModal: React.FC<SaveChangesModalProps> = ({ onCancel, onClose, onDiscard }) => {
  const { t: translate } = useTranslation();
  
  const handleLeaveWithoutSaving = () => {
    if (onDiscard) {
      onDiscard();
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <button className={styles.closeButton} onClick={onClose}>
          <SvgIcon component={cross} />
        </button>
        <div className={styles.topSection}>
          <div className={styles.iconContainer}>
            <SvgIcon component={exclamatory}
              viewBox="0 0 40 40"
              sx={{
                fontSize: '2.23rem'
              }} />
          </div>
          <h2 className={styles.title}>{translate('Changes Found!')}</h2>
          <p className={styles.message}>You have unsaved changes. Are you sure you want to leave this page?</p> 
        </div>
        <div className={styles.bottomSection}>
          <div className={styles.actions}>
            <button className={styles.cancelButton} onClick={onCancel}>
              {translate('Stay')}
            </button>
            <button className={styles.discardButton} onClick={handleLeaveWithoutSaving}>
            {translate('Leave')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
